'use client';

import classnames from 'classnames';

import type { BaseComponentProps } from '../../base-component.types';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../tooltip';

import styles from './Title.module.scss';

export type TitleType = BaseComponentProps & {
  text: string;
  info?: string;
  variant?: 'bold' | 'regular';
};

function Title({
  style,
  className,
  text,
  info,
  variant = 'regular',
  testId = 'ui-list-title',
}: TitleType) {
  if (info) {
    return (
      <Tooltip placement="top">
        <TooltipTrigger asChild={true}>
          <div
            style={style}
            className={classnames(
              styles['text'],
              variant && styles[`text--${variant}`],
              className,
            )}
          >
            {text}
          </div>
        </TooltipTrigger>
        <TooltipContent
          data-testid={testId}
          className={styles['tooltip-content']}
        >
          {info}
        </TooltipContent>
      </Tooltip>
    );
  }

  return (
    <div
      data-testid={testId}
      style={style}
      className={classnames(
        styles['text'],
        variant && styles[`text--${variant}`],
        className,
      )}
    >
      {text}
    </div>
  );
}

export { Title };
